import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'

Vue.use(VueRouter)

const routes = [
  {
    path: '/register/step-1',
    name: 'register-step-one',
    component: () =>
      import(/* WebpackChunkName: "StepOne" */ '@/views/Common/Registration/StepOne'),
    meta: {
      title: 'Регистрация/Шаг 1'
    }
  },
  {
    path: '/register/step-2',
    name: 'register-step-two',
    component: () =>
      import(/* WebpackChunkName: "StepTwo" */ '@/views/Common/Registration/StepTwo'),
    meta: {
      title: 'Регистрация/Шаг 2'
    }
  },
  {
    path: '/login',
    name: 'ModalLogin',
    props: { visible: true },
    component: () => import(/* WebpackChunkName: "ModalLogin" */ '@/components/Auth/ModalLogin.vue')
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import(/* WebpackChunkName: "Payment" */ '@/views/Common/Payment'),
    meta: {
      title: 'Регистрация/Шаг 2'
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'users',
        name: 'userIndex',
        redirect: { name: 'studentEducation' },
        component: () => import(/* WebpackChunkName: "usersIndex" */ '@/views/Users/index.vue'),
        children: [
          {
            path: 'student/education',
            name: 'studentEducation',
            component: () =>
              import(
                /* WebpackChunkName: "studentEducation" */ '@/views/Users/Student/Education.vue'
              )
          },
          {
            path: 'student/education/:id',
            name: 'studentEducationList',
            component: () =>
              import(
                /* WebpackChunkName: "studentEducationList" */ '@/views/Users/EducationList.vue'
              )
          },
          {
            path: 'profile',
            name: 'profile',
            component: () =>
              import(/* WebpackChunkName: "UsersProfile" */ '@/views/Users/UsersProfile.vue')
          }
        ]
      },
      {
        path: 'admin',
        name: 'adminsIndex',
        redirect: { name: 'analytics' },
        component: () => import(/* WebpackChunkName: "adminsIndex" */ '@/views/Admins/index.vue'),
        children: [
          {
            path: 'analytics',
            name: 'analytics',
            component: () =>
              import(
                /* WebpackChunkName: "analytics" */ '@/views/Admins/Admin/Analytics/Analytics.vue'
              )
          },
          {
            path: 'courses',
            name: 'courses',
            component: () =>
              import(/* WebpackChunkName: "courses" */ '@/views/Admins/Admin/Courses/Courses.vue')
          },
          {
            path: 'courses/:id',
            name: 'course',
            component: () =>
              import(/* WebpackChunkName: "course" */ '@/views/Admins/Admin/Courses/Course.vue'),
            children: [
              {
                path: 'edit-module',
                name: 'edit-module',
                params: true,
                component: () =>
                  import(/* WebpackChunkName: "edit" */ '@/views/Admins/Admin/Courses/Course.vue')
              },
              {
                path: 'overview',
                name: 'overview',
                params: true,
                component: () =>
                  import(
                    /* WebpackChunkName: "overview" */ '@/views/Admins/Admin/Courses/Course.vue'
                  )
              },
              {
                path: 'edit-level/:levelId',
                name: 'edit-level',
                params: true,
                component: () =>
                  import(/* WebpackChunkName: "level" */ '@/views/Admins/Admin/Courses/Course.vue')
              },
              {
                path: 'edit-day/:dayId',
                name: 'edit-day',
                params: true,
                component: () =>
                  import(/* WebpackChunkName: "day" */ '@/views/Admins/Admin/Courses/Course.vue')
              },
              {
                path: 'edit-task/:taskId',
                name: 'edit-task',
                params: true,
                component: () =>
                  import(/* WebpackChunkName: "task" */ '@/views/Admins/Admin/Courses/Course.vue')
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/trial-lessons',
    name: 'trial-lessons',
    component: () => import(/* WebpackChunkName: "TrialLesson" */ '@/views/Common/TrialLesson'),
    meta: {
      title: 'Пробный урок'
    }
  }
]

const router = new VueRouter({
  mode: process.env.NODE_ENV === 'development' ? 'history' : 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router

router.beforeEach((to, from, next) => {
  if (to.name !== 'ModalLogin' && !localStorage.getItem('auth')) next({ name: 'ModalLogin' })
  else next()
})
